<template>
  <gg-card>
    <gg-card-header>
      Manage Access Hosts
      <gg-text-field v-model="search" placeholder="Search..." append-icon="mdi-magnify" class="float-right" hide-details />
    </gg-card-header>
    <gg-card-text>
      <v-data-table :headers="headers"
                    :search="search"
                    :loading="loading"
                    :items="mysqlRemoteHosts"
      >
        <template v-slot:item.actions="{ item }">
          <gg-btn @click="showDeleteModal(item.host)">
            Delete
          </gg-btn>
        </template>
      </v-data-table>
      <delete-host-modal :opened="deleteModalOpened"
                         :host="selectedHost"
                         @close="closeDeleteModal"
                         @host-deleted="reloadHosts"></delete-host-modal>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteHostModal from './DeleteHostModal'

export default {
  name: 'HostsTable',
  components: {
    DeleteHostModal,
  },
  props: {
    tableShouldBeReloaded: {
      type: Boolean,
      required: true,
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'Access Host',
          value: 'host',
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false,
        }
      ],
      search: '',
      loading: false,
      deleteModalOpened: false,
      selectedHost: '',
    }
  },
  computed: {
    ...mapGetters({
      mysqlRemoteHosts: 'mysql/mysqlRemoteHosts',
    })
  },
  methods: {
    ...mapActions({ getMysqlRemoteHosts: 'mysql/getMysqlRemoteHosts' }),
    async reloadHosts () {
      try {
        this.loading = true
        await this.getMysqlRemoteHosts(this.$route.query.user)
        this.$emit('table-reloaded')
      } catch (e) {
        console.warn(e)
      } finally {
        this.loading = false
      }
    },
    showDeleteModal (host) {
      this.deleteModalOpened = true
      this.selectedHost = host
    },
    closeDeleteModal () {
      this.deleteModalOpened = false
      this.selectedHost = ''
    },
  },
  watch: {
    deleteModalOpened (val) {
      if (!val) {
        this.selectedHost = ''
      }
    },
    tableShouldBeReloaded (val) {
      if (val) {
        this.reloadHosts()
      }
    }
  },
  created () {
    this.reloadHosts()
  }
}
</script>
